import { apiFetch } from "./api";

export interface TranscriptSegmentPayload {
  seq: number;
  text: string;
  ts_ms: number;
  url?: string | null;
  is_final: true;
}

export interface PersistedTranscriptEntry extends TranscriptSegmentPayload {
  id: number;
  context_id: string | null;
  session_id: string;
  created_at: string;
}

interface TranscriptPage {
  entries: PersistedTranscriptEntry[];
  total: number;
  offset: number;
  limit: number;
}

export async function appendTranscriptBatch(
  sessionId: string,
  segments: TranscriptSegmentPayload[],
): Promise<{ accepted: number; duplicates: number }> {
  const response = await apiFetch(`/sessions/${sessionId}/transcript`, {
    method: "POST",
    body: JSON.stringify(segments),
  });
  if (!response.ok) {
    throw new Error(`append transcript: ${response.status}`);
  }
  return response.json() as Promise<{ accepted: number; duplicates: number }>;
}

export async function loadTranscriptHistory(
  sessionId: string,
): Promise<PersistedTranscriptEntry[]> {
  const entries: PersistedTranscriptEntry[] = [];
  const limit = 500;
  let offset = 0;

  // The total is read anew on every page so concurrent appends are not lost.
  for (;;) {
    const response = await apiFetch(
      `/sessions/${sessionId}/transcript?offset=${offset}&limit=${limit}`,
    );
    if (!response.ok) {
      throw new Error(`load transcript: ${response.status}`);
    }
    const page = (await response.json()) as TranscriptPage;
    entries.push(...page.entries);
    offset += page.entries.length;
    if (page.entries.length === 0 || offset >= page.total) break;
  }

  return entries;
}
